import React from "react";
import { useTranslation } from "react-i18next";

const LanguageSelect = () => {
    const { i18n } = useTranslation();

    const handleChange = (e) => {
        i18n.changeLanguage(e.target.value);
    };

    return (
        <select
            onChange={handleChange}
            value={i18n.language.startsWith("vi") ? "vi" : "en"}
            className="border border-white/40 bg-white/10 text-white text-sm rounded px-2 py-1"
        >
            <option value="en">EN</option>
            <option value="vi">VI</option>
        </select>
    );
};

export default LanguageSelect;

